// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1NTqf1ctWUfago4BqUAO0R"};